import sensors from 'sa-sdk-javascript'
import { getIsLogin, getInitUserInfo } from './account';
import store from '../store'
import { configRead } from '../api/slicer/printer'

let client_type = 'web';
let business_domain = 'slicer_fdm';
let sub_domain = 'fdm';
let language, regionCn, prod, deviceID, userInfo;

export const sliceSensors = async () => {
  //  写入初始化参数
  await textInitQuary();

  sensors.init({
    server_url: 'https://api-cdp.anycubic.com/sa?project=default',
    app_js_bridge: true,
    show_log: prod === '0',
    is_track_single_page: true,
    use_client_time: true,
    send_type: 'beacon',
    referrer_domain_black: ['.*'],
    heatmap: {
      clickmap: 'default',
      scroll_notice_map: 'default'
    }
  });
  sensors.registerPage({
    client_type,
    business_domain,
    sub_domain,
    language: function () {
      return language.split('_')[0] ? language.split('_')[0]: 'en'
    },
    identity_anonymous_id: deviceID,
    is_login: function () {
      const res = store.state.user?.uploadCenter_user_info
      return res ? true : false
    },
  });

  sensors.use('PageLeave');
  // 修改这里，改用setOnceProfile并确保在autoTrack之前执行
  sensors.setOnceProfile({ "first_visit_domain": business_domain + '|' + sub_domain });

  // 给SDK一点初始化时间后再执行autoTrack
  setTimeout(function () {
    sensors.quick('autoTrack');
  }, 100);
}

sliceSensors();

//  url中的query转换成对象
function getUrlParams (search) {
  let params = {};
  search.split("&").forEach((pair) => {
    if (pair) {
      let [key, value] = pair.split("=");
      params[decodeURIComponent(key)] = decodeURIComponent(value || "");
    }
  });
  return params;
}

//  初次进入，那url上hash参数，后续从本地存储拿参数
async function textInitQuary () {  
  let prodStr = localStorage.getItem('prod')
  let regionCnStr = localStorage.getItem('regionCn')
  let languageStr = localStorage.getItem('language')
  if (!prodStr || !regionCnStr || !languageStr) {
    const urlQuery = getUrlParams(window.location.hash.split('?')[1]);
    prod = urlQuery.prod;
    regionCn = urlQuery.regionCn;
    language = urlQuery.language;
  } else {
    prod = prodStr;
    regionCn = regionCnStr;
    language = languageStr;
  }
  const { status, user_info } = await getInitUserInfo();
  deviceID = await configRead('pc_device_id')
  if (status == 1) {
    const userInfoObj = user_info ? JSON.parse(user_info) : {};
    userInfo = regionCn === '1' ? userInfoObj?.mobile : userInfoObj?.user_email;
    sensors.login(userInfo);
  } else {
    sensors.logout();
  }
}

//  用户登录sdk传入，同步处理神策sdk用户登录
window.setUserLogin = setUserLogin;

//  神策登录或退登(神策sdk init之后执行)
function setUserLogin (state, userInfo) {
  let regionCn = localStorage.getItem('regionCn')
  if (!regionCn) {
    const urlQuery = getUrlParams(window.location.hash.split('?')[1]);
    regionCn = urlQuery.regionCn;
  }
  if (state == 1) {
    const userInfoObj = userInfo ? JSON.parse(userInfo) : {};
    const info = regionCn === '1' ? userInfoObj?.mobile : userInfoObj?.user_email;
    sensors.login(info);
  } else {
    sensors.logout();
  }
}